// extracted by mini-css-extract-plugin
export default {"highlighted":"g__highlighted--N5l92"};